import dicomImageLoader from '@cornerstonejs/dicom-image-loader';
import dcmjs from 'dcmjs';

class FileLoader {
  fileType;
  loadFile(file, callback) {}
  getDataset(file, imageId) {}
  readFile(file, callback) {}
}

const cacheImageToFile = async (buffer, url) => {
  try {
    const file = new File([buffer], url, { type: buffer.type });
    return file;
  } catch (e) {
    throw new Error('Error caching image to file');
  }
};

const fetchImage = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }
    const arrayBuffer = await response.arrayBuffer();
    const file = await cacheImageToFile(arrayBuffer, url);
    const service = new FileLoaderService(file);
    const fileId = service.addFile(file);
    const dataset = await service.getDataset(arrayBuffer, fileId);
    return dataset;
  } catch (e) {
    console.error(`%c[DICOM ERROR] Không thể tải ảnh từ URL: ${url}`, 'color: #f44336; font-weight: bold;', e);
    throw e;
  }
};

export { fetchImage };

const DICOMFileLoader = new class extends FileLoader {
  fileType = 'application/dicom';
  loadFile(file, callback) {
    return dicomImageLoader.wadouri.loadFileRequest(callback);
  }
  getDataset(buffer, imageId) {
    const dicomMessage = dcmjs.data.DicomMessage.readFile(buffer);
    const dataset = dcmjs.data.DicomMetaDictionary.naturalizeDataset(dicomMessage.dict);
    dataset.url = imageId;
    dataset._meta = dcmjs.data.DicomMetaDictionary.namifyDataset(dicomMessage.meta);
    dataset.TransferSyntaxUID = dataset.TransferSyntaxUID || dataset._meta?.AvailableTransferSyntaxUID?.Value?.[0];
    return dataset;
  }
}();

class FileLoaderService extends FileLoader {
  fileType;
  loader;
  constructor(file) {
    super();
    const type = file && file.type;
    this.loader = this.getLoader(type);
    this.fileType = this.loader?.fileType;
  }
  addFile(file) {
    return dicomImageLoader.wadouri.fileManager.add(file);
  }
  loadFile(file, callback) {
    return this.loader.loadFile(file, callback);
  }
  getDataset(buffer, imageId) {
    return this.loader.getDataset(buffer, imageId);
  }
  getLoader(type) {
    return type === 'application/pdf' ? PDFFileLoader : DICOMFileLoader;
  }
}

const PDFFileLoader = new class extends FileLoader {
  fileType = 'application/pdf';
  loadFile(file, callback) {
    return dicomImageLoader.wadouri.loadFileRequest(callback);
  }
  getDataset(buffer, imageId) {
    const result = {};
    result.imageId = buffer.imageId || imageId;
    return result;
  }
}();
